const initialState = {
  // Getting Receiving List
  isGettingReceivingList: false,
  receivingList: [],
  page: 0,
  totalResults: 0,

  // is Adding Receiving
  isAddingReceiving: false,

  // is Updating Receiving
  isUpdatingReceiving: false,

  // is Deleting Receiving
  isDeletingReceiving: false,

  // Next receiving number for the create form
  isGettingNextReceivingNumber: false,
  nextReceivingNumber: "",
};

const ReceivingReducer = (state = initialState, action) => {
  switch (action.type) {
    // Getting Receiving List
    case "RECEIVING_LIST_REQUEST":
      return { ...state, isGettingReceivingList: true };
    case "RECEIVING_LIST_SUCCESS":
      return {
        ...state,
        receivingList: action.payload?.data,
        page: action.payload?.page,
        totalResults: action.payload?.totalResults,
        isGettingReceivingList: false,
      };
    case "RECEIVING_LIST_ERROR":
      return { ...state, isGettingReceivingList: false };

    // Adding Receiving
    case "ADD_RECEIVING_REQUEST":
      return { ...state, isAddingReceiving: true };
    case "ADD_RECEIVING_SUCCESS":
      return { ...state, isAddingReceiving: false };
    case "ADD_RECEIVING_ERROR":
      return { ...state, isAddingReceiving: false };

    // Updating Receiving
    case "UPDATE_RECEIVING_REQUEST":
      return { ...state, isUpdatingReceiving: true };
    case "UPDATE_RECEIVING_SUCCESS":
      return { ...state, isUpdatingReceiving: false };
    case "UPDATE_RECEIVING_ERROR":
      return { ...state, isUpdatingReceiving: false };

    // Deleting Receiving
    case "DELETE_RECEIVING_REQUEST":
      return { ...state, isDeletingReceiving: true };
    case "DELETE_RECEIVING_SUCCESS":
      return { ...state, isDeletingReceiving: false };
    case "DELETE_RECEIVING_ERROR":
      return { ...state, isDeletingReceiving: false };

    // Next receiving number
    case "NEXT_RECEIVING_NUMBER_REQUEST":
      return { ...state, isGettingNextReceivingNumber: true };
    case "NEXT_RECEIVING_NUMBER_SUCCESS":
      return {
        ...state,
        nextReceivingNumber: action.payload?.receivingNumber || "",
        isGettingNextReceivingNumber: false,
      };
    case "NEXT_RECEIVING_NUMBER_ERROR":
      return { ...state, isGettingNextReceivingNumber: false };

    default:
      return state;
  }
};

export default ReceivingReducer;
